import dash1 from '../../assets/images/dashboard/p-1.png';
import dash2 from '../../assets/images/dashboard/p-2.png';
import dash3 from '../../assets/images/dashboard/p-3.png';
import user1 from '../../assets/images/dashboard/social/1.png';
import user2 from '../../assets/images/dashboard/social/2.png';
import user3 from '../../assets/images/dashboard/social/3.png';
import user4 from '../../assets/images/dashboard/social/4.png';
import user5 from '../../assets/images/dashboard/social/5.png';

export const DealerTables = [
    {
        srno: '01',
        img: dash1,
        name: 'Ossim keter',
        year: '2022',
        date: '16 August',
        place: 'Graden',
        flag: 'flag-icon flag-icon-gb',
        prize: '$1,58,652'
    },
    {
        srno: '02',
        img: dash2,
        name: 'Venter loren',
        year: '2022',
        date: '21 September',
        place: 'Business Hub',
        flag: 'flag-icon flag-icon-us',
        prize: '$95,025'
    },
    {
        srno: '03',
        img: dash3,
        name: 'Fran loain',
        year: '2022',
        date: '06 March',
        place: 'Water Park',
        flag: 'flag-icon flag-icon-za',
        prize: '$90,155 '
    },
];

export const SocialReviewImg = [
    {
        img: user1
    },
    {
        img: user2
    },
    {
        img: user3
    },
    {
        img: user4
    },
    {
        img: user5
    },
];

export const CalanderData = [
    {
        class: 'round-light icon-secondary',
        icon: 'fa fa-user',
        title: 'All Employe Distribute Work',
        place: 'Company,SanFrancisco',
        time: '9: 00 to 10: 00'
    },
    {
        class: 'round-light icon-primary',
        icon: 'fa fa-check-circle',
        title: 'Business Plan is Approved',
        place: 'Elisse Joson,San Francisco',
        time: '10: 00 to 1: 00'
    },
    {
        class: 'round-light icon-success',
        icon: 'fa fa-graduation-cap',
        title: 'Our Education Project Presentation',
        place: 'Company,San Francisco',
        time: '1: 10 to 3: 15'
    },
    {
        class: 'round-light icon-warning',
        icon: 'fa fa-coffee',
        title: 'Coffe Break',
        place: 'Our Company All Team Member',
        time: '3: 15 to 3: 30'
    },
];

export const TodayProject = [
    {
        task: 'Google Project Apply Review',
        time: 'Completed in 3 Hours',
        class: 'progress-bar bg-primary',
        width: '75%',
        percent: '75% Percentage',
        btnclass: 'btn light-primary',
        btn: 'Edit'
    },
    {
        task: 'Business Logo Create',
        time: 'Completed in 5 Hours',
        class: 'progress-bar bg-secondary',
        width: '100%',
        percent: 'Completed',
        btnclass: 'btn light-secondary',
        btn: 'Edit'
    },
    {
        task: 'Business Project Research',
        time: 'Completed in 2 Hours',
        class: 'progress-bar bg-success',
        width: '65%',
        percent: '65% Percentage',
        btnclass: 'btn light-success',
        btn: 'Edit'
    },
    {
        task: 'Recruitment in IT Department',
        time: 'Completed in 4 Days',
        class: 'progress-bar bg-warning',
        width: '90%',
        percent: '90% Percentage',
        btnclass: 'btn light-warning',
        btn: 'Edit'
    },
    {
        task: 'Submit Riverfront Project',
        time: 'Completed in 2 Days',
        class: 'progress sm-progress-bar',
        width: '30',
        percent: '30% Percentage',
        btnclass: 'btn light-info',
        btn: 'Edit'
    }
];

export const QuickOptionData = [
    {
        id: 1,
        class: 'icofont icofont-bill-alt txt-primary',
        price: '25500',
        title: 'Cash On Hand'
    },
    {
        id: 2,
        class: 'icofont icofont-bank-alt txt-secondary',
        price: '30000',
        title: 'Bank balance'
    },
    {
        id: 3,
        class: 'icofont icofont-mastercard txt-success',
        price: 'Mastercard',
        title: 'Credit card'
    },
    {
        id: 4,
        class: 'icofont icofont-trophy-alt txt-info',
        price: '435.5',
        title: 'Total cashback'
    },
    {
        id: 5,
        class: 'icofont icofont-ticket txt-warning',
        price: 'Unlock 5',
        title: 'Coupans'
    },
    {
        id: 6,
        class: 'icofont icofont-maestro txt-danger',
        price: '3500',
        title: 'Win Points'
    },
];